<template>
    <div class="float-left mr-2">
        <span
            class="text-danger"
            v-if="$temAcessoView('ADMIN-TIPMOV-01')"
        >
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import TiposMovimentosServicos from './TiposMovimentosServicos'

export default {
    props: {
        tipoMovimento: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Tipo de Movimento',
                html: `Confirma a exclusão do tipo de movimento <b>${this.tipoMovimento.codTipoMovimento}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.excluirTipoMovimento(this.tipoMovimento.codTipoMovimento).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Tipo de movimento excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizar')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }

    }
}
</script>
